import config from "../config/config";

const regex =
  /^[12][0-9]{2}[0-1][0-9](2[AB]|[0-9]{2})[0-9]{3}[0-9]{3}[0-9]{2}$/;

export const ValidateNir = (
  nni: string,
  birthDate: string,
  gender: number,
  department?: string
) => {
  // const regex = /^[1-2]\d{2}\d{2}\d{2}\d{6}\d{2}$/; // Exemple de format pour un NIR
  const cleanedNni = nni.replace(/\s/g, "");

  // Extraire les parties du NIR
  const NIR = cleanedNni.substring(0, 13); // Les 13 premiers chiffres
  const key = cleanedNni.substring(13, 15); // Les deux derniers chiffres (clé de contrôle)
  const sexe = cleanedNni.charAt(0); // 1 pour homme, 2 pour femme
  const anneeNaissance = parseInt(cleanedNni.slice(1, 3), 10);
  const moisNaissance = parseInt(cleanedNni.slice(3, 5), 10);
  // const codeDepartement = cleanedNni.slice(5, 7);
  if (!nni) {
    return {
      isValid: false,
      message: "Veuillez entrer votre numéro de sécurité sociale",
    };
  }

  if (!config.debugMode) {
    // Valider le format de base du NIR
    if (!regex.test(cleanedNni)) {
      return {
        isValid: false,
        message:
          "Veuillez entrer un numéro de sécurité sociale valide (format incorrect).",
      };
    }

    // Vérifier la clé de contrôle
    if (parseInt(key) !== 97 - (parseInt(NIR) % 97)) {
      return {
        isValid: false,
        message: "Veuillez entrer un numéro de sécurité sociale valide",
        // message: "Clé de contrôle invalide.",
      };
    }

    // Vérification de la date de naissance
    const birthYear = birthDate.split("-")[2];
    const birthMonth = birthDate.split("-")[1];
    const calculatedYear =
      anneeNaissance < 50 ? 2000 + anneeNaissance : 1900 + anneeNaissance;

    if (
      parseInt(birthYear, 10) !== calculatedYear ||
      parseInt(birthMonth, 10) !== moisNaissance
    ) {
      return {
        isValid: false,
        message:
          "La date de naissance ne correspond pas au numéro de sécurité sociale.",
      };
    }

    // Vérification du sexe
    if ((gender === 1 && sexe !== "1") || (gender === 2 && sexe !== "2")) {
      return {
        isValid: false,
        message: "Le genre ne correspond pas au numéro de sécurité sociale.",
      };
    }
  }

  // // Vérification du département de naissance
  // if (department !== codeDepartement) {
  //   return {
  //     isValid: false,
  //     message: "Le département de naissance ne correspond pas au numéro de sécurité sociale.",
  //   };
  // }

  // Si toutes les vérifications passent
  return {
    isValid: true,
    message: "",
  };
};

const ValidateNni = (nni: string) => {
  let NIR = nni.replace(/\s/g, "").substring(0, 13);
  let key = nni.replace(/\s/g, "").substring(13, 15);
  if (
    !regex.test(nni.replace(/\s/g, "")) &&
    !["3", "7", "8"].includes(nni.replace(/\s/g, "").charAt(0))
  ) {
    return {
      isValid: false,
      message: "Veuillez entrer un numéro de sécurité sociale valide",
    };
  } else if (
    parseInt(key) !== 97 - (parseInt(NIR) % 97) &&
    !["3", "7", "8"].includes(nni.replace(/\s/g, "").charAt(0))
  ) {
    return {
      isValid: false,
      message: "Veuillez entrer un numéro de sécurité sociale valide",
    };
  } else {
    return {
      isValid: true,
      message: "",
    };
  }
};

export default ValidateNni;
